import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      className="sticky top-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 px-3 py-2 text-center text-sm font-medium text-white"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      Sei offline: vedi gli ultimi dati salvati. Sopralluoghi, verbali e allegati verranno inviati al ritorno della rete; le altre modifiche non vengono registrate.
    </div>
  );
};

export default OfflineBanner;
